import { Grid } from "@mui/material";
import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowCheckpointStore } from "../../../../../store";
import { OnlyPhoto } from "../../../shared-component";
import { Image } from "antd";
import noImg from "../../../../../assets/images/not-found.jpg";

export const SellosSalidaExporbananas = ({widthFull}: {widthFull: string}) => {

  const adhesivoPuertaCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.adhesivoPuertaCheckPhoto
  );
  const adhesivoBisagraCheckPhoto1 = useWorkflowCheckpointStore(
    (state) => state.adhesivoBisagraCheckPhoto1
  );
  const adhesivoBisagraCheckPhoto2 = useWorkflowCheckpointStore(
    (state) => state.adhesivoBisagraCheckPhoto2
  );
  const adhesivoBisagraCheckPhoto3 = useWorkflowCheckpointStore(
    (state) => state.adhesivoBisagraCheckPhoto3
  );
  const cableExporCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.cableExporCheckPhoto
  );
  const botellaExporCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.botellaExporCheckPhoto
  );

  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white" }}
    >
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
          <EtiquetaPuertaPhoto widthFull={widthFull} />
        </div>
        <Image
          src={
            adhesivoPuertaCheckPhoto === "" ? noImg : adhesivoPuertaCheckPhoto
          }
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
          <EtiquetaBisagraPhoto1 widthFull={widthFull} />
        </div>
        <Image
          src={
            adhesivoBisagraCheckPhoto1 === ""
              ? noImg
              : adhesivoBisagraCheckPhoto1
          }
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
          <EtiquetaBisagraPhoto2 widthFull={widthFull} />
        </div>
        <Image
          src={
            adhesivoBisagraCheckPhoto2 === ""
              ? noImg
              : adhesivoBisagraCheckPhoto2
          }
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
          <EtiquetaBisagraPhoto3 widthFull={widthFull} />
        </div>
        <Image
          src={
            adhesivoBisagraCheckPhoto3 === ""
              ? noImg
              : adhesivoBisagraCheckPhoto3
          }
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
          <SelloCablePhoto widthFull={widthFull} />
        </div>
        <Image
          src={cableExporCheckPhoto === "" ? noImg : cableExporCheckPhoto}
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
          <SelloBotellPhoto widthFull={widthFull} />
        </div>
        <Image
          src={botellaExporCheckPhoto === "" ? noImg : botellaExporCheckPhoto}
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
    </Grid>
  );
};

//SELLO SALIDA EXPORTADOR

const EtiquetaPuertaPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openAdhesivo,
    handleClose: handleCloseAdhesivo,
    handleOpen: handleOpenAdhesivo,
  } = useOpen();

  const adhesivoPuertaPhoto = useWorkflowCheckpointStore(
    (state) => state.adhesivoPuertaPhoto
  );

  const setAdhesivoPuertaPhoto = useWorkflowCheckpointStore(
    (state) => state.setAdhesivoPuertaPhoto
  );
  const fotoUrl = useBlobUrl(adhesivoPuertaPhoto);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      label="ETIQUETA PUERTA"
      handleClose={handleCloseAdhesivo}
      handleOpen={handleOpenAdhesivo}
      open={openAdhesivo}
      setFoto={setAdhesivoPuertaPhoto}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};

const EtiquetaBisagraPhoto1 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openCableVerificadora1,
    handleClose: handleCloseCableVerificadora1,
    handleOpen: handleOpenCableVerificadora1,
  } = useOpen();

  const adhesivoBisagraPhoto1 = useWorkflowCheckpointStore(
    (state) => state.adhesivoBisagraPhoto1
  );

  const setAdhesivoBisagraPhoto1 = useWorkflowCheckpointStore(
    (state) => state.setAdhesivoBisagraPhoto1
  );
  const fotoUrl = useBlobUrl(adhesivoBisagraPhoto1);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseCableVerificadora1}
      handleOpen={handleOpenCableVerificadora1}
      label="ETIQUETA BISAGRA FOTO 1"
      open={openCableVerificadora1}
      setFoto={setAdhesivoBisagraPhoto1}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};

const EtiquetaBisagraPhoto2 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openCableVerificadora2,
    handleClose: handleCloseCableVerificadora2,
    handleOpen: handleOpenCableVerificadora2,
  } = useOpen();

  const adhesivoBisagraPhoto2 = useWorkflowCheckpointStore(
    (state) => state.adhesivoBisagraPhoto2
  );

  const setAdhesivoBisagraPhoto2 = useWorkflowCheckpointStore(
    (state) => state.setAdhesivoBisagraPhoto2
  );
  const fotoUrl = useBlobUrl(adhesivoBisagraPhoto2);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseCableVerificadora2}
      handleOpen={handleOpenCableVerificadora2}
      label="ETIQUETA BISAGRA FOTO 2"
      open={openCableVerificadora2}
      setFoto={setAdhesivoBisagraPhoto2}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};

const EtiquetaBisagraPhoto3 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openCableVerificadora3,
    handleClose: handleCloseCableVerificadora3,
    handleOpen: handleOpenCableVerificadora3,
  } = useOpen();

  const adhesivoBisagraPhoto3 = useWorkflowCheckpointStore(
    (state) => state.adhesivoBisagraPhoto3
  );

  const setAdhesivoBisagraPhoto3 = useWorkflowCheckpointStore(
    (state) => state.setAdhesivoBisagraPhoto3
  );
  const fotoUrl = useBlobUrl(adhesivoBisagraPhoto3);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseCableVerificadora3}
      handleOpen={handleOpenCableVerificadora3}
      label="ETIQUETA BISAGRA FOTO 3"
      open={openCableVerificadora3}
      setFoto={setAdhesivoBisagraPhoto3}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};

const SelloCablePhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openBotellaVerificadoraRastreo,
    handleClose: handleCloseBotellaVerificadoraRastreo,
    handleOpen: handleOpenBotellaVerificadoraRastreo,
  } = useOpen();

  const cableExporPhoto = useWorkflowCheckpointStore(
    (state) => state.cableExporPhoto
  );

  const setCableExporPhoto = useWorkflowCheckpointStore(
    (state) => state.setCableExporPhoto
  );
  const fotoUrl = useBlobUrl(cableExporPhoto);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseBotellaVerificadoraRastreo}
      handleOpen={handleOpenBotellaVerificadoraRastreo}
      label="SELLO CABLE"
      open={openBotellaVerificadoraRastreo}
      setFoto={setCableExporPhoto}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};

const SelloBotellPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openNumRastreoSatelital,
    handleClose: handleCloseNumRastreoSatelital,
    handleOpen: handleOpenNumRastreoSatelital,
  } = useOpen();

  const botellaExporPhoto = useWorkflowCheckpointStore(
    (state) => state.botellaExporPhoto
  );

  const setBotellaExporPhoto = useWorkflowCheckpointStore(
    (state) => state.setBotellaExporPhoto
  );
  const fotoUrl = useBlobUrl(botellaExporPhoto);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseNumRastreoSatelital}
      handleOpen={handleOpenNumRastreoSatelital}
      label="SELLO BOTELLA"
      open={openNumRastreoSatelital}
      setFoto={setBotellaExporPhoto}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};
